import { useQueryParamObject } from "polyrouter";

export type ActionQueryParams = "ActionsFilterState";

export type ActionFilterState = {
  action?: string;
};

export const defaultFilterState: ActionFilterState = {
  action: undefined
};

export type SetActionFilter = (paramsObj: ActionFilterState) => void;

export const useActionsFilter: () => [
  ActionFilterState,
  SetActionFilter,
  () => void
] = () => {
  const [urlState, setFilter, clear] = useQueryParamObject<
    ActionQueryParams,
    ActionFilterState
  >("ActionsFilterState");
  const filterState = urlState || defaultFilterState;
  return [filterState, setFilter, clear];
};
